import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const ChannelUpdates = Loadable({
    loader: () => import('./ChannelUpdates'),
    render(loaded, props) {
      const Component = connect((state) => ({
        bankcardChannelUpdatesState: state.bankcardChannelUpdatesState,
        siteConfig: state.siteConfig
      }), {
        init,
        submit
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/channel-updates`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <ChannelUpdates {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
